import Notifications from "../containers/Notifications"

export default Notifications
